export const navy = "#27343e";
export const white = "#ffffff";
export const blue = "#3E90A9";
